import { getToken } from './token';
import { getUserInfo } from './userInfo';
import { getCustomers } from './getCustomers';

export const AOSApi = {
    getToken,
    getUserInfo,
    getCustomers,
};

export * from './types';
